import styled from 'styled-components';
import { ThemePrisma } from '@orbita-ui/brand';

export const LoginPageContainer = styled.div`
  background-color: #e6ebf2;
  min-height: 100vh;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  flex-direction: column;
`;

export const LoginTopContainer = styled.div`
  flex: 1 0 0;
  align-self: stretch;
  flex-direction: row;
  display: flex;
`;

export const LoginFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  justify-content: center;
  align-items: center;
  background-color: ${ThemePrisma.colors.lightblue[7]};
  min-width: 320px;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: ${ThemePrisma.colors.lightblue[7]};
    z-index: 1;
    transform: skewX(5deg);
    right: 60px;
  }
`;
